import ModalManager from '@restart/ui/ModalManager';
import kebabCase from 'lodash/kebabCase';
import { getScrollbarSize } from '../dom-helpers';
const Selector = {
    FIXED_CONTENT: '.fixed-top, .fixed-bottom, .is-fixed, .sticky-top',
    STICKY_CONTENT: '.sticky-top',
    NAVBAR_TOGGLER: '.navbar-toggler'
};
class BootstrapModalManager extends ModalManager {
    adjustAndStore(prop, element, adjust) {
        const actual = element.style[prop];
        // @ts-expect-error DOMStringMap and CSSStyleDeclaration aren't strictly compatible
        element.dataset[prop] = actual;
        element.style.setProperty(kebabCase(prop), `${parseFloat(actual) + adjust}px`);
    }
    restore(prop, element) {
        const value = element.dataset[prop];
        if (value !== undefined) {
            delete element.dataset[prop];
            element.style.setProperty(kebabCase(prop), value);
        }
    }
    setContainerStyle(containerState) {
        super.setContainerStyle(containerState);
        const container = this.getElement();
        if (!containerState.overflowing) return;
        const size = getScrollbarSize();
        Array.from(container.querySelectorAll(Selector.FIXED_CONTENT)).forEach((el)=>this.adjustAndStore('paddingRight', el, size));
        Array.from(container.querySelectorAll(Selector.STICKY_CONTENT)).forEach((el)=>this.adjustAndStore('marginRight', el, -size));
        Array.from(container.querySelectorAll(Selector.NAVBAR_TOGGLER)).forEach((el)=>this.adjustAndStore('marginRight', el, size));
    }
    removeContainerStyle(containerState) {
        super.removeContainerStyle(containerState);
        const container = this.getElement();
        Array.from(container.querySelectorAll(Selector.FIXED_CONTENT)).forEach((el)=>this.restore('paddingRight', el));
        Array.from(container.querySelectorAll(Selector.STICKY_CONTENT)).forEach((el)=>this.restore('marginRight', el));
        Array.from(container.querySelectorAll(Selector.NAVBAR_TOGGLER)).forEach((el)=>this.restore('marginRight', el));
    }
}
export { BootstrapModalManager as default };
